import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { Time } from '@instinet-analytics/core-lib';
import { StrikeBenchmark } from 'widgets/estimatedTradeCost/components/options';
import { strikeTimeToString } from 'widgets/estimatedTradeCost/store/data/mapping';

export type EstimatedTradeCostOptimization = {
    benchmark?: string;
    profile?: string;
    minPartLit?: number;
    maxPartLit?: number;
    strikeTime?: Time;
};

export const toOptimizationUid = (opt: EstimatedTradeCostOptimization) =>
    `Benchmark:${opt.benchmark}/Profile:${opt.profile}/MinPL:${
        opt.minPartLit ?? 0
    }/MaxPL:${opt.maxPartLit ?? 0}${
        opt.benchmark === StrikeBenchmark && opt.strikeTime
            ? `/StrikeTime:${strikeTimeToString(opt.strikeTime)}`
            : ''
    }`;

export type EstimatedTradeCostConfigState = EstimatedTradeCostOptimization &
    WidgetConfigWithHideableToolbar;

export const getInitialEstimatedTradeCostConfigState: () => EstimatedTradeCostConfigState =
    () => ({
        maxPartLit: 100,
    });
